module.exports = __webpack_public_path__ + "static/img/whatsapp.63717146.svg";